import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  back() {
    const url = new URL(window.location);
    url.searchParams.delete("edit");
    window.history.replaceState({}, "", url);
  }
}
